import { StarFillIcon } from '@dpa/react-icons';
import { RtChips } from '@dpa/react-chips';

type TProps = {
  index: number;
  handleUpdateRating: (rating: number) => void;
};

const icon = () => <StarFillIcon size="sm" specification="main" />;

export const StarChips = ({ index, handleUpdateRating }: TProps) => {
  const label = (index + 1).toString();
  const handleOnClick = () => handleUpdateRating(index + 1);

  return (
    <RtChips
      label={label}
      leadingIcon={icon}
      size="sm"
      use="generic"
      modifier="mono"
      onClick={handleOnClick}
    />
  );
};
